import React, { Component } from "react";
import { Translation } from "react-i18next";
import { styles } from "./Preview.css";
import { connect } from "react-redux";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  withStyles,
  Grid,
} from "@material-ui/core";
import Moment from "react-moment";
import UserDisplay from "../../../util/UserDisplay";
import { __getTrackStatusByID } from "../../../_clearance/utils/utils";
import { __getQuestionAndAnswer } from "../../../_clearance/utils/utils";
import { checkCollisions } from "../../../redux/actions/MlLicFormContentActions";
import { AiFillWarning } from "react-icons/ai";


class TrackCollisions extends Component {

  constructor(props) {
    super();
    this.state = {
      dialogOpen: false,
      trackCollisionsData: [],
      loadingData: false,
      error: null,
    }
    this.openDialog = this.openDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  viewCollisions = () =>{
    const {
      data : {editing, selectedItem},
      props: {loadCollisions}
    } = this.props;

    if(loadCollisions && selectedItem){
      this.setState({loadingData: true},()=>{
        loadCollisions(selectedItem.trackDetails?.id, editing, (data, errors)=>{
          if(data && !errors){
            this.setState({
              trackCollisionsData: data,
              loadingData: false,
              dialogOpen: true,
              error: null
            });
          }else if(!data && errors){
            this.setState({
              trackCollisionsData: [],
              loadingData: false,
              dialogOpen: true,
              error: errors
            });
          }else{
            this.setState({
              trackCollisionsData: [],
              loadingData: false,
              dialogOpen: true,
              error: null
            });
          }
        });
      })
    }

  }

  openDialog() {
    this.setState({ dialogOpen: true, });
  }

  closeDialog() {
    const {trackCollisionsData} = this.state;
    const {
      checkCollisions,
      data : {editing, selectedItem},
    } = this.props;

    this.setState({ 
      dialogOpen: false,
      loadingData: false,
      error: null
     },()=>{
      if(!trackCollisionsData.length){
        checkCollisions({cf: editing});
      }
    });
  }

  getFormType = (type) => {
    const { runtime: { runtime } } = this.props;
    let fType = "";
    if (runtime?._config?.CLEARANCE_FORM_TYPE_LIST?.length) {
      fType = runtime._config.CLEARANCE_FORM_TYPE_LIST.find(t => t.value === type)?.label ?? '';
    }
    return fType;
  }

  getUserGroupName = (group) => {
    const { inbox: { allGroups } } = this.props;
    let groupName = "";
    if (allGroups.length) {
      groupName = allGroups.find(g => g.externalRefId === group)?.name ?? ''
    }

    return groupName;
  }

  render() {
    const {
      classes,
      data: { selectedItem },
    } = this.props;

    const {trackCollisionsData, loadingData, error} = this.state;

    return (
      <Translation>
        {(t, { i18n }) => (
          <>
            <Button
            className={classes.collisionButton}
              aria-label={"View Collisions"}
              onClick={() => this.viewCollisions()}
              disabled={loadingData || false}
              title="View Collisions"
            >
              
              <AiFillWarning style={{fontSize: "15px",  marginRight:"5px"}}></AiFillWarning>View Collisions
              {loadingData &&  <CircularProgress/>}</Button>
            <Dialog
              open={this.state.dialogOpen}
              id="clearance-details"
              aria-labelledby="clearance-details-dialog"
              className={"clearancePopup"}
              maxWidth={"sm"}
            >
              <DialogTitle>Track Collisions</DialogTitle>
              <DialogContent style={{paddingTop:"0"}}>
               
                  { trackCollisionsData.length > 0 ? 
                  trackCollisionsData?.map(c => {
                      return (
                        <>
                        <Grid className={classes.collisionItem} container>
                          <Grid item xs={12}>
                            <strong>{selectedItem?.trackDetails?.trackTitle}</strong>
                            {c.ctPerformer?.length > 0 &&  <div><small>{c.ctPerformer.join(', ')}</small></div>}
                            {c.ctUsage && 
                              <div>
                                <small>Usage: {c.ctUsage}</small>
                              </div>
                            }
                          </Grid>
                          <Grid item xs={6}>
                            <div>
                              <span>Clearance Form</span>
                              <strong>: {c.cfName}</strong>
                            </div>
                            <div>
                              <span>Production</span>
                              <strong>: {this.getFormType(c.cfType)}</strong>
                            </div>
                            <div>
                              <span>Term / TX Dates</span>
                              <strong>: {Array.isArray(c.txDates) && c.txDates.length && c.txDates.join(' - ')}</strong>
                            </div>
                          </Grid>
                          <Grid item xs={6}>
                            <div>
                              <span>Created By</span>
                              <strong>: {<UserDisplay userId={c.ctCreatedBy} /> || t("libraryPreview.na")}</strong>
                            </div>
                            <div>
                              <span>Department</span>
                              <strong>: {this.getUserGroupName(c.cfUserGroup)}</strong>
                            </div>
                            <div>
                              <span>Date of last edit</span>
                              <strong>: {<Moment
                                format="DD/MM/YYYY h:mm:ss A"
                                titleFormat="DD/MM/YYYY h:mm:ss A"
                                withTitle
                              >
                                {c.ctupdatedAt}
                              </Moment>}</strong>
                            </div>
                          </Grid>
                          </Grid>
                        </>
                      )
                    })
                    :
                    <>
                    {!error ? 
                    <h4>No Collision Data Found.</h4>
                    :
                    <h4>Error Loading Collision Data</h4>
                    }
                    </>
                  }
              </DialogContent>
              <DialogActions>
                <Button
                  className={classes.dialogNoButton}
                  aria-label={"Close Popup"}
                  onClick={(e) => {
                    this.closeDialog();
                  }}
                  autoFocus
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.mllicformcontent,
  runtime: state.clearanceRuntime,
  cfForm: state.mllicform,
  inbox: state.inbox
});

export default connect(mapStateToProps, {
  checkCollisions
})(withStyles(styles)(TrackCollisions));
